var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.510665 7.2032L7.22903 0.766087C7.45403 0.576243 7.66496 0.498899 7.84426 0.498899C8.02356 0.498899 8.26508 0.57691 8.4275 0.734024L15.1775 7.2032C15.5149 7.52312 15.5258 8.08914 15.2028 8.395C14.882 8.73337 14.3457 8.74438 14.0107 8.42026L7.84426 2.50984L1.67785 8.41609C1.34387 8.74019 0.806681 8.72919 0.485704 8.39082C0.162618 8.08914 0.173164 7.52312 0.510665 7.2032Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.2c49cbd4a4d5b2f0efe334fd0cc5c3a1.svg";
export { ForwardRef as ReactComponent };